module.exports = __webpack_public_path__ + "img/EscalatorWarningOutlined.9ae412fd.svg";